export const ACCOUNT_STATEMENT_ACCEPTED_FILES = {
  "text/csv": [".csv"],
  "application/pdf": [".pdf"],
};

export const STRIPE_STATEMENT_ACCEPTED_FILES = {
  "application/pdf": [".pdf"],
};

export const UNPARSED_CSV_STATEMENT_ERROR =
  "We couldn't read columns from this CSV. Please check the file and try again.";
